/* ===== header.js — TTP Leathers Design System v1.0 ===== */
/* Mega Menu & Header UX Controller                          */
/* Vanilla JS IIFE — no jQuery, no external deps            */

(function () {
  'use strict';

  /* ── Constants ─────────────────────────────────────── */
  const HEADER_EL   = document.querySelector('.bh-header-section');
  const NAV_ITEMS   = document.querySelectorAll('[data-nav-item]');
  const OPEN_CLASS  = 'is-open';
  const SCROLL_CLASS = 'is-scrolled';

  /* Hover intent delay (ms) — prevents accidental trigger on mouse pass */
  const OPEN_DELAY  = 80;
  const CLOSE_DELAY = 220;

  /* ── Header scroll state ────────────────────────────── */
  function updateScrollState() {
    if (!HEADER_EL) return;
    if (window.scrollY > 20) {
      HEADER_EL.classList.add(SCROLL_CLASS);
    } else {
      HEADER_EL.classList.remove(SCROLL_CLASS);
    }
  }

  /* Throttle scroll handler to avoid layout thrashing */
  let scrollTicking = false;
  window.addEventListener('scroll', function () {
    if (!scrollTicking) {
      window.requestAnimationFrame(function () {
        updateScrollState();
        scrollTicking = false;
      });
      scrollTicking = true;
    }
  }, { passive: true });

  updateScrollState(); // run once on load

  /* ── Update CSS variable for mega menu top offset ─── */
  function updateHeaderHeight() {
    if (!HEADER_EL) return;
    const h = HEADER_EL.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--bh-header-height', h + 'px');
  }

  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight, { passive: true });

  /* ── Nav item hover intent ──────────────────────────── */
  NAV_ITEMS.forEach(function (item) {
    let openTimer  = null;
    let closeTimer = null;
    const trigger  = item.querySelector('[data-nav-trigger]');

    function openItem() {
      clearTimeout(closeTimer);
      openTimer = setTimeout(function () {
        // Close all others first
        NAV_ITEMS.forEach(function (other) {
          if (other !== item) {
            other.classList.remove(OPEN_CLASS);
            var t = other.querySelector('[data-nav-trigger]');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.add(OPEN_CLASS);
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      }, OPEN_DELAY);
    }

    function closeItem() {
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () {
        item.classList.remove(OPEN_CLASS);
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }, CLOSE_DELAY);
    }

    /* Mouse events */
    item.addEventListener('mouseenter', openItem);
    item.addEventListener('mouseleave', closeItem);

    /* Keep open if moving from trigger to panel */
    var panel = item.querySelector('.bh-mega-menu, .bh-dropdown');
    if (panel) {
      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      panel.addEventListener('mouseleave', closeItem);
    }

    /* Keyboard: Enter or Space on trigger */
    if (trigger) {
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var isOpen = item.classList.contains(OPEN_CLASS);
          if (isOpen) {
            item.classList.remove(OPEN_CLASS);
            trigger.setAttribute('aria-expanded', 'false');
          } else {
            NAV_ITEMS.forEach(function (other) {
              other.classList.remove(OPEN_CLASS);
              var t = other.querySelector('[data-nav-trigger]');
              if (t) t.setAttribute('aria-expanded', 'false');
            });
            item.classList.add(OPEN_CLASS);
            trigger.setAttribute('aria-expanded', 'true');
          }
        }
        /* Escape closes */
        if (e.key === 'Escape') {
          item.classList.remove(OPEN_CLASS);
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
      });
    }
  });

  /* ── Global Escape key listener ────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      NAV_ITEMS.forEach(function (item) {
        item.classList.remove(OPEN_CLASS);
        var t = item.querySelector('[data-nav-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* ── Click outside to close ─────────────────────────── */
  document.addEventListener('click', function (e) {
    var isInsideNav = e.target.closest('.bh-nav-desktop-links');
    if (!isInsideNav) {
      NAV_ITEMS.forEach(function (item) {
        item.classList.remove(OPEN_CLASS);
        var t = item.querySelector('[data-nav-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* ── Language Switcher (Desktop Dropdown) ────────────── */
  var langTrigger  = document.querySelector('[data-lang-trigger]');
  var langSwitcher = document.querySelector('.bh-lang-switcher');

  if (langTrigger && langSwitcher) {
    langTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = langSwitcher.classList.contains(OPEN_CLASS);

      /* Close all mega/dropdown nav items first */
      NAV_ITEMS.forEach(function (item) {
        item.classList.remove(OPEN_CLASS);
        var t = item.querySelector('[data-nav-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });

      if (isOpen) {
        langSwitcher.classList.remove(OPEN_CLASS);
        langTrigger.setAttribute('aria-expanded', 'false');
      } else {
        langSwitcher.classList.add(OPEN_CLASS);
        langTrigger.setAttribute('aria-expanded', 'true');
      }
    });

    /* Keyboard support */
    langTrigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        langTrigger.click();
      }
      if (e.key === 'Escape') {
        langSwitcher.classList.remove(OPEN_CLASS);
        langTrigger.setAttribute('aria-expanded', 'false');
        langTrigger.focus();
      }
    });

    /* Click outside to close lang dropdown */
    document.addEventListener('click', function (e) {
      if (!langSwitcher.contains(e.target)) {
        langSwitcher.classList.remove(OPEN_CLASS);
        langTrigger.setAttribute('aria-expanded', 'false');
      }
    });

    /* Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        langSwitcher.classList.remove(OPEN_CLASS);
        langTrigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

})();
